var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323,
    height: 108,
    viewBox: "0 0 323 108",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8166 88.4229C66.4922 85.5865 54.8008 80.3288 43.1745 74.6697C5.04781 56.0944 -5.31552 35.2229 25.1469 21.335C72.504 -0.182746 175.04 -2.61019 250.793 18.561C267.572 23.2405 290.433 28.6801 305.88 40.6997C320.25 51.8768 317.926 62.0023 309.154 70.2979C300.211 78.8118 284.559 85.4386 272.319 89.3434C218.813 106.363 116.128 113.025 28.5749 86.4294C26.7724 85.8982 24.8672 85.9964 24.2237 86.6331C23.5803 87.2699 24.375 88.1946 26.0459 88.7044C116.17 116.078 222.09 109.441 277.161 91.9264C292.392 87.0523 312.741 78.0889 320.015 66.5698C324.942 58.6895 323.854 49.6363 311.41 39.8877C295.009 27.0931 270.744 21.1573 252.935 16.1834C174.73 -5.67731 68.689 -3.26158 19.8653 18.9761C-12.924 33.8953 -2.00446 56.3124 38.9984 76.2819C51.494 82.4026 64.341 88.0258 80.9753 91.1038C82.8091 91.4426 84.4809 91.1162 84.6043 90.3586C84.8592 89.6224 83.5189 88.7403 81.8166 88.4229Z",
    fill: "#E3FF3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.3ce1ca9113417d9ffa22a27c3fd53a7c.svg";
export { ForwardRef as ReactComponent };